<template>
  <div class="shippingDetail custSupport">
    <header v-if="showHeader">
      <span class="back" @click="goBack()"
        ><img src="../assets/images/back.svg" alt
      /></span>
      <!-- <h1>Notice Board</h1> -->
    </header>
    <section class="fake_news" :class="{ paddingTop: showHeader }">
      <div class="shop-registercnt">
      <!-- <header class="inner-head">
        <span class="icon-btn goback">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="22"
            viewBox="0 0 21 22"
          >
            <g fill="none" fill-rule="evenodd">
              <g stroke="#000">
                <path
                  d="M19.5 10L0 10M9.75.25L0 10 9.75 19.75"
                  transform="translate(-15 -15) translate(16 16)"
                />
              </g>
            </g>
          </svg>
        </span>
      </header> -->
      <section class="mid-panel">
        <div class="saving-cnt">
          <h1>अब बचत ही बचत</h1>
          <div class="category-banner">
            <div class="ctg-col">
              <div class="ctg-imgbox">
                <img src="https://5.imimg.com/data5/IX/PQ/KX/ANDROID-68159242/1557480928597-jpg-500x500.jpg" alt="milk" />
              </div>
              <div class="title-blk">
                <h3>अब दूध पर</h3>
                <span class="price">Rs. 11/- की छूट</span>
              </div>
            </div>
            <div class="ctg-col">
              <div class="ctg-imgbox">
                <img
                  src="https://cdn.mall91.com/7dd16f2d-61e4-4d28-896b-c87b55db8c78_medium.jpg"
                  alt="milk"
                />
              </div>
              <div class="title-blk">
                <h3>रोज़ाना किराना पर</h3>
                <span class="price">10% की बचत + cashbacks</span>
              </div>
            </div>
          </div>
          <div class="video-box">
            <iframe
              src="https://www.youtube.com/embed/Dcsmh46MO2Y"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </section>

      <footer class="ftr-panel">
        <h2>अभी रजिस्टर करवाओ - अपने पास की दुकान को</h2>
        <div class="button-blk">
          <span class="whtsapp-btn" @click="shareFunc()">दूकानदार को What’sApp करे </span>
          <span class="shop-btn" @click="openWhatsAppShop('9654897767')">दुकान की डिटेल्स दें </span>
        </div>
      </footer>
    </div>
    </section>
  </div>
</template>

<script>
import ApiCaller from '../utils/apicaller';
import constant from '../utils/constant';
import { replcePhoneWithAsterik } from '../utils/helper';
export default {
  name: 'NoticeBoard',
  data() {
    return {
      showHeader: false,
      leaderBoardList: [],
      isLeaderBoard: false,
    };
  },
  methods: {
    openWhatsAppShop(_whatsAppNumber){
       try {
          JSBridgePlugin.fireEvents("WHATSAPP_TO_SHOPKEEPER");
        } catch (err) {
          console.log(err);
        }
      try {
        JSBridgePlugin.genericIntentLaunch(
          `https://wa.me/+91${_whatsAppNumber}?text=मैं अपने पिनकोड में नई दूकान को Mall91 लोकल शॉपिंग में जोड़ना चाहता हूँ - दूकान का नाम, नंबर नोट करें (अपनी दूकान का नाम, नंबर भेजें)`
        );
      } catch (error) {
        console.log('error')
      }
    },
    shareFunc(){
      try {
          JSBridgePlugin.fireEvents("WHATSAPP_TO_SHOPKEEPER");
        } catch (err) {
          console.log(err);
        }
      const obj = {
        message: 'मैं LocalShop91 ऐप से रोज़ की शॉपिंग पास की दुकानों से करता हूँ - अपनी दूकान फटाफट बनाएं और अपने प्रोडक्ट्स जोड़ें - आपको हर दिन कम से कम 10 से 15 ग्राहक और ऑर्डर्स मिलेंगे! यह कैसे होगा? LocalShop91 भारत की सबसे बड़ी सोशल शॉपिंग ऐप Mall91 की पेशकश है - जहाँ पर हर छोटे से छोटे गाँव/कसबे/शहर के 2 करोड़ से ज़्यादा कस्टमर्स हैं - आपके प्रोडक्ट्स को सभी कस्टमर्स को दिखाया जाता है जो डिस्काउंट लगा कर आपकी दूकान से आर्डर करते हैं - आपको पूरी कीमत मिलती है, चिंता ना करें!\n\n दुकान कैसे बनाएं?  \n https://bit.ly/397emIw \n\n अपने प्रोडक्ट्स कैसे जोड़ें? \n https://bit.ly/3q3SzrQ',
        imageUrl: null
      };
      try {
        JSBridgePlugin.share(JSON.stringify(obj));
      } catch (err) {
        console.log(err);
        window.open("whatsapp://send?text=" + 'मैं LocalShop91 ऐप से रोज़ की शॉपिंग पास की दुकानों से करता हूँ - अपनी दूकान फटाफट बनाएं और अपने प्रोडक्ट्स जोड़ें - आपको हर दिन कम से कम 10 से 15 ग्राहक और ऑर्डर्स मिलेंगे! यह कैसे होगा? LocalShop91 भारत की सबसे बड़ी सोशल शॉपिंग ऐप Mall91 की पेशकश है - जहाँ पर हर छोटे से छोटे गाँव/कसबे/शहर के 2 करोड़ से ज़्यादा कस्टमर्स हैं - आपके प्रोडक्ट्स को सभी कस्टमर्स को दिखाया जाता है जो डिस्काउंट लगा कर आपकी दूकान से आर्डर करते हैं - आपको पूरी कीमत मिलती है, चिंता ना करें!\n\n दुकान कैसे बनाएं?  \n https://bit.ly/397emIw \n\n अपने प्रोडक्ट्स कैसे जोड़ें? \n https://bit.ly/3q3SzrQ');
      }
    },
    goBack() {
      if (this.$cookie.get('version-code') > 57) {
        if (window.history.length == 1) {
          try {
            JSBridgePlugin.gotToHome();
          } catch (err) {
            console.log(err);
          }
        } else {
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    },
  },
  mounted() {
    if (!this.$route.query.showingToolbar) {
      this.showHeader = true;
    }
    // this.getLeaderBoardData();
  },
};
</script>
<style lang="scss" scoped>@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;900&display=swap');
* {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
  word-break: break-word;
}
* ::-webkit-scrollbar {
  display: none;
}
html {
  scroll-behavior: smooth;
}
input:focus {
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}
::-webkit-input-placeholder {
  color: #999999;
}
ul,
li {
  padding: 0px;
  margin: 0px;
  list-style: none;
}
body {
  font-size: 16px;
  background: #fff;
  font-family: 'Roboto', sans-serif;
  -webkit-transition: all ease 0.5s;
  transition: all ease 0.5s;
  color: #e9dcdc;
  scroll-behavior: smooth;
}
input,
textarea {
  font-family: 'Roboto', sans-serif;
}
.shop-registercnt {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow-y: auto;
  background: #ffffff;
}
.shop-registercnt .inner-head {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  padding: 12px 16px;
  background: #fff;
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  z-index: 1;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.shop-registercnt .inner-head .icon-btn {
  width: 32px;
  height: 32px;
  position: relative;
  display: inline-block;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-flex: 0;
  -ms-flex-positive: 0;
  flex-grow: 0;
  left: -4px;
}
.shop-registercnt .inner-head .icon-btn svg {
  width: 22px;
  height: 22px;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  fill: #505050;
}
.shop-registercnt .inner-head h2 {
  font-size: 1em;
  color: #262626;
  font-weight: 600;
}
.shop-registercnt .mid-panel {
  padding: 8px 16px 16px 16px;
}
.shop-registercnt .saving-cnt {
  margin-bottom: 150px;
}
.shop-registercnt .saving-cnt h1 {
  font-size: 2.5em;
  color: #505050;
  display: block;
  text-align: center;
  font-weight: 300;
}
.shop-registercnt .saving-cnt .category-banner {
  width: 100%;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin: 24px 0;
}
.shop-registercnt .saving-cnt .category-banner .ctg-col {
  width: 50%;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  -webkit-box-flex: 0;
  -ms-flex-positive: 0;
  flex-grow: 0;
}
.shop-registercnt .saving-cnt .category-banner .ctg-col .ctg-imgbox {
  width: 100%;
  height: auto;
  -webkit-box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.3);
  background: #fff;
  padding: 4px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 4px 0 0 4px;
}
.shop-registercnt .saving-cnt .category-banner .ctg-col .ctg-imgbox img {
  width: 155px;
  height: 155px;
}
.shop-registercnt .saving-cnt .category-banner .ctg-col .title-blk {
  width: 100%;
  margin: 8px 0 0 0;
  display: block;
  text-align: center;
}
.shop-registercnt .saving-cnt .category-banner .ctg-col .title-blk h3 {
  font-size: 0.875em;
  color: #505050;
  font-weight: 300;
}
.shop-registercnt .saving-cnt .category-banner .ctg-col .title-blk .price {
  font-size: 0.875em;
  color: #000000;
  font-weight: bold;
}
.shop-registercnt .saving-cnt .category-banner .ctg-col:last-child .ctg-imgbox {
  border-radius: 4px 4px 4px 4px;
  -webkit-transform-origin: left top;
  transform-origin: left top;
  -webkit-transform: skew(0deg, 0deg);
  transform: skew(0deg, 0deg);
  position: relative;
}
.shop-registercnt
  .saving-cnt
  .category-banner
  .ctg-col:last-child
  .ctg-imgbox
  img {
  -webkit-transform: skew(0);
  transform: skew(0);
}
.shop-registercnt .saving-cnt .video-box {
  width: 100%;
  display: block;
}
.shop-registercnt .saving-cnt .video-box iframe {
  width: 100%;
  height: 185px;
  border-radius: 4px;
  border: 0px;
  outline: none;
}
.shop-registercnt .ftr-panel {
  width: 100%;
  position: fixed;
  bottom: 0px;
  left: 0px;
  padding: 16px;
  background: #fff;
}
.shop-registercnt .ftr-panel h2 {
  display: block;
  color: #505050;
  font-size: 1em;
  font-weight: bold;
  text-align: center;
  margin-bottom: 16px;
}
.shop-registercnt .ftr-panel .button-blk {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.shop-registercnt .ftr-panel .button-blk span {
  font-size: 0.875em;
  color: #fff;
  font-weight: 500;
  padding: 8px 12px;
  background: #000;
  border-radius: 4px;
  display: inline-block;
  text-align: center;
  -webkit-transition: all ease 0.3s;
  transition: all ease 0.3s;
}
.shop-registercnt .ftr-panel .button-blk span.whtsapp-btn {
  background: #149307;
  margin: 0 2px 0 0;
}
.shop-registercnt .ftr-panel .button-blk span.shop-btn {
  background: #ffa43a;
  margin: 0 0px 0 2px;
}
.shop-registercnt .ftr-panel .button-blk span:active {
  opacity: 0.8;
}
</style>
